import { adminFetch } from './dataProvider';
import { CrmConnection, CrmConnectionInput } from './types';

/**
 * CRM connection management calls. These use `adminFetch` directly rather
 * than the Refine data provider because the backend routes live under
 * `/v1/admin/crm/connections` (a nested path the resource-name convention
 * `/v1/admin/{resource}` does not produce).
 */

export const fetchCrmConnections = (): Promise<CrmConnection[]> =>
  adminFetch<{ connections: CrmConnection[] }>('/v1/admin/crm/connections').then(
    (r) => r.connections,
  );

/**
 * Create/edit a Salesforce connection on the portal's own-company plane
 * (p6). Create POSTs `/v1/admin/crm/connections` — the body carries no
 * `companyId` (the backend's portal-plane schema has no such field; the
 * caller's token already scopes the company, so `CrmConnectionInput`'s
 * `companyId` stays optional and this plane never sets it). Edit PUTs
 * `/v1/admin/crm/connections/{id}` — a blank `secrets` field is simply
 * omitted by the caller (`SalesforceConnectionForm`), which preserves the
 * stored secret server-side.
 */
export const saveCrmConnection = (
  mode: 'create' | 'edit',
  id: string | undefined,
  body: CrmConnectionInput,
): Promise<CrmConnection> =>
  adminFetch<CrmConnection>(
    mode === 'create' ? '/v1/admin/crm/connections' : `/v1/admin/crm/connections/${id}`,
    { method: mode === 'create' ? 'POST' : 'PUT', body: JSON.stringify(body) },
  );

export const deleteCrmConnection = (id: string): Promise<void> =>
  adminFetch<void>(`/v1/admin/crm/connections/${id}`, { method: 'DELETE' });

export const testCrmConnection = (
  id: string,
): Promise<{ status: 'ok' | 'error'; message: string }> =>
  adminFetch<{ status: 'ok' | 'error'; message: string }>(
    `/v1/admin/crm/connections/${id}/test`,
    { method: 'POST' },
  );
